import React from "react"
import {useTranslation} from "react-i18next"
import {twMerge} from "tailwind-merge"

import {Badge} from "../../../components/Badge"
import {ASalesAssistantDeal, ASalesAssistantDealPriorities} from "../../../services/types.generated"
import {enumTranslKey} from "../../../utils/i18n"

export const PriorityBadgeCell: React.FC<{row: Pick<ASalesAssistantDeal, "priority">}> = ({row}) => {
  const {t} = useTranslation()
  const {priority} = row

  if (!priority) {
    return "-"
  }

  return (
    <Badge
      color={"custom"}
      className={twMerge(
        priority === ASalesAssistantDealPriorities.Low && "bg-[#CDEED6] text-[#03A934]",
        priority === ASalesAssistantDealPriorities.Medium && "bg-[#FEF0C7] text-[#F79009]",
        priority === ASalesAssistantDealPriorities.High && "bg-[#F2B4B5] text-[#BA1C1C]"
      )}
    >
      {t(enumTranslKey("SalesAssistantDealPriority", priority))}
    </Badge>
  )
}
